export default class PostMiddleware {
  init(app) {
    // placeholder for post routes middleware.
  }
}



// WEBPACK FOOTER //
// ./src/api/middleware/post.js